var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cancelled"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancelled",
    clipPath: "url(#clip-Cancelled)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22106",
    "data-name": "Path 22106",
    d: "M18.4,0A18.4,18.4,0,1,1,0,18.4,18.4,18.4,0,0,1,18.4,0Z",
    transform: "translate(0.53 0.53)",
    fill: "rgba(255,66,0,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11705",
    "data-name": "Group 11705",
    transform: "translate(10.76 10.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22104",
    "data-name": "Path 22104",
    d: "M8.17,0a8.135,8.135,0,0,1,8.162,8.194A8.167,8.167,0,1,1,0,8.173,8.141,8.141,0,0,1,8.17,0m6.711,8.184a6.71,6.71,0,1,0-13.42-.012,6.71,6.71,0,1,0,13.42.012",
    transform: "translate(0 -0.001)",
    fill: "#e33b00",
    stroke: "#e33b00",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22105",
    "data-name": "Path 22105",
    d: "M117.635,116.882c.377-.381.7-.7,1.015-1.026.2-.2.4-.408.606-.6a.719.719,0,0,1,1.011,1.021c-.467.479-.943.95-1.417,1.422a1.355,1.355,0,0,1-.185.129c.079.086.119.133.163.177l1.405,1.409a.694.694,0,0,1,.212.745.724.724,0,0,1-.589.509.7.7,0,0,1-.642-.235q-.693-.69-1.381-1.384a1.886,1.886,0,0,1-.138-.178c-.077.071-.124.111-.168.155-.473.473-.943.95-1.42,1.42a.677.677,0,0,1-.714.2.727.727,0,0,1-.527-.573.7.7,0,0,1,.231-.661q.69-.692,1.382-1.383c.049-.049.108-.089.177-.144-.064-.07-.1-.118-.147-.161q-.709-.711-1.418-1.421a.683.683,0,0,1-.206-.73.727.727,0,0,1,.581-.519.69.69,0,0,1,.645.227q.7.7,1.4,1.41a1.112,1.112,0,0,1,.118.191",
    transform: "translate(-109.497 -109.678)",
    fill: "#e33b00",
    stroke: "#e33b00",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/Cancelled.f484a7e19901ce70d7ac17ee8c442ba2.svg";
export { ForwardRef as ReactComponent };